/**
 * Include your custom JavaScript here.
 * Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' (see Warehouse docs).
 */

/*
 * 21 Sep 2026, Distinct Picks: keep the Shopify Inbox chat button ("Need help?") from covering the
 * Checkout button on phones. The chat floats bottom right; on screens up to 640px we add space under the
 * mini-cart buttons and under the cart page, so the buttons sit above the chat instead of behind it.
 * Desktop is unchanged.
 */
(function () {
  var css =
    '@media screen and (max-width: 640px) {' +
    '  .mini-cart__recap { padding-bottom: 88px; }' +
    '  .template-cart #main { padding-bottom: 88px; }' +
    '}' +
    '.mini-cart__dp-notice { font-size: 0.8125em; line-height: 1.4; margin: 6px 0 10px; opacity: 0.85; }' +
    '.button--primary { border: 1px solid #0f1c2e; font-weight: 600; }'; /* 5 Oct 2026: gold buttons with navy text and a thin navy border, site-wide */
  var style = document.createElement('style');
  style.setAttribute('data-dp', 'cart-chat-spacing');
  style.textContent = css;
  document.head.appendChild(style);
})();

/*
 * 21 Sep 2026, Distinct Picks: shipping is free, so the cart page notice no longer says shipping is
 * calculated at checkout. The link to the shipping policy is kept. Re-applied when the theme re-renders
 * the cart after a quantity change.
 * 30 Sep 2026: the store does not collect sales tax in any US state (Shopify > Settings > Taxes, 30 Sep 2026),
 * so "Taxes calculated at checkout" promised an amount that never appears. The notice now says so. If the
 * store ever registers to collect tax in a state, change TEXT and DRAWER_TEXT back.
 * 5 Oct 2026: notice extended (cart page and drawer) with tracking, pay over time and the phone number as a
 * tap-to-call link, so the last screen before checkout answers the usual doubts of a first-time buyer.
 */
(function () {
  var TEXT = ' to the contiguous US, with tracking emailed as soon as it ships. No sales tax. Pay over time at checkout. Questions? Call ';
  var PHONE = '855-772-2008';
  var PHONE_HREF = 'tel:+18557722008';
  var HOURS = ', Mon to Fri 9 to 6 ET.';

  function fixNotice() {
    var notices = document.querySelectorAll('.cart-recap__notices p');
    for (var i = 0; i < notices.length; i++) {
      var p = notices[i];
      if (p.getAttribute('data-dp-free-shipping') === '1') continue;
      var link = p.querySelector('a');
      var href = link ? link.getAttribute('href') : '/policies/shipping-policy';
      p.innerHTML = '';
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.textContent = 'Free shipping';
      p.appendChild(a);
      p.appendChild(document.createTextNode(TEXT));
      var tel = document.createElement('a');
      tel.setAttribute('href', PHONE_HREF);
      tel.textContent = PHONE;
      p.appendChild(tel);
      p.appendChild(document.createTextNode(HOURS));
      p.setAttribute('data-dp-free-shipping', '1');
    }
  }

  function start() {
    if (!document.body || document.body.className.indexOf('template-cart') === -1) return;
    fixNotice();
    new MutationObserver(fixNotice).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 30 Sep 2026, Distinct Picks: the same line in the cart drawer (mini-cart), above the View cart and
 * Checkout buttons, so a buyer sees the full picture before the checkout asks for an address.
 * The drawer is re-rendered by the theme after every cart change, so the line is re-added when missing.
 */
(function () {
  var DRAWER_TEXT = 'Free shipping to the contiguous US, with tracking emailed as soon as it ships. No sales tax. Pay over time at checkout. Questions? Call ';

  function addDrawerNotice() {
    var recaps = document.querySelectorAll('#mini-cart .mini-cart__recap');
    for (var i = 0; i < recaps.length; i++) {
      var recap = recaps[i];
      if (recap.querySelector('.mini-cart__dp-notice')) continue;
      var buttons = recap.querySelector('.mini-cart__button-container');
      if (!buttons) continue;
      var p = document.createElement('p');
      p.className = 'mini-cart__dp-notice';
      p.appendChild(document.createTextNode(DRAWER_TEXT));
      var tel = document.createElement('a');
      tel.setAttribute('href', 'tel:+18557722008');
      tel.style.textDecoration = 'underline';
      tel.textContent = '855-772-2008';
      p.appendChild(tel);
      p.appendChild(document.createTextNode(', Mon to Fri 9 to 6 ET.'));
      recap.insertBefore(p, buttons);
    }
  }

  function start() {
    if (!document.body) return;
    addDrawerNotice();
    new MutationObserver(addDrawerNotice).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 4 Oct 2026, Distinct Picks: product page on phones.
 * 1. Warranty paragraph: where the brand's warranty is confirmed (snippets/dp-warranty.liquid writes it into
 *    #dp-warranty-long), the general "Warranty." paragraph in Shipping, Returns & Warranty shows that term instead.
 * 2. Photo counter "1 / 6" on the photo, because the thumbnail row is hidden on phones (snippets/dp-product-mobile.liquid).
 * 3. A bar with price and Add to cart at the bottom of the screen on phones whenever the main button is out of view.
 *    The bar's button clicks the main button, so variant choice and the cart drawer work exactly as before.
 *    The chat button moves up while the bar is visible, and is hidden while the main button is on screen
 *    (on phones it would cover the Add to cart button); it comes back as soon as the buyer scrolls.
 */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function warrantyParagraph() {
    var data = document.getElementById('dp-warranty-long');
    if (!data) return;
    var text;
    try { text = JSON.parse(data.textContent); } catch (e) { return; }
    if (!text) return;
    var paragraphs = document.querySelectorAll('.product-block-list__item--content .rte p');
    for (var i = 0; i < paragraphs.length; i++) {
      var p = paragraphs[i];
      if (p.textContent.trim().indexOf('Warranty.') !== 0) continue;
      p.innerHTML = '';
      p.appendChild(document.createTextNode('Warranty. ' + text + ' If anything goes wrong, you contact us and we deal with the manufacturer. See our '));
      var a = document.createElement('a');
      a.setAttribute('href', '/pages/warranty');
      a.textContent = 'Warranty page';
      p.appendChild(a);
      p.appendChild(document.createTextNode('.'));
      break;
    }
  }

  function galleryCounter() {
    var wrapper = document.querySelector('.product-block-list__item--gallery .product-gallery__carousel-wrapper');
    var items = document.querySelectorAll('.product-block-list__item--gallery .product-gallery__carousel-item');
    if (!wrapper || items.length < 2) return;
    var counter = document.createElement('span');
    counter.className = 'dp-gallery-count';
    wrapper.appendChild(counter);
    function update() {
      var index = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-selected')) { index = i; break; }
      }
      counter.textContent = (index + 1) + ' / ' + items.length;
    }
    update();
    var observer = new MutationObserver(update);
    for (var j = 0; j < items.length; j++) {
      observer.observe(items[j], { attributes: true, attributeFilter: ['class'] });
    }
  }

  function stickyBar() {
    var main = document.querySelector('.product-block-list__item--info .product-form__add-button');
    if (!main || main.disabled) return;
    var phone = window.matchMedia('(max-width: 640px)');

    var bar = document.createElement('div');
    bar.className = 'dp-sticky-atc';
    var price = document.createElement('span');
    price.className = 'dp-sticky-atc__price';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--primary dp-sticky-atc__btn';
    button.textContent = main.textContent.trim() || 'Add to cart';
    bar.appendChild(price);
    bar.appendChild(button);
    document.body.appendChild(bar);

    function priceText() {
      var el = document.querySelector('.product-block-list__item--info .price-list .price');
      if (!el) return '';
      var copy = el.cloneNode(true);
      var hidden = copy.querySelectorAll('.visually-hidden');
      for (var i = 0; i < hidden.length; i++) hidden[i].parentNode.removeChild(hidden[i]);
      return copy.textContent.trim().replace(/\.00$/, '');
    }

    function refresh() {
      price.textContent = priceText();
      button.disabled = main.disabled;
      button.textContent = main.textContent.trim() || 'Add to cart';
    }
    refresh();
    document.addEventListener('variant:changed', function () { setTimeout(refresh, 60); });

    button.addEventListener('click', function () {
      if (!main.isConnected) check();
      main.click();
    });

    var mainInView = true;
    function apply() {
      // 5 Oct 2026: on phones the bar is always visible, so price and button are on screen from the first
      // moment while the page above keeps its full-size photo, thumbnails and title.
      var show = phone.matches && !main.disabled;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('dp-sticky-on', show);
      document.body.classList.toggle('dp-buy-in-view', mainInView && phone.matches);
    }
    // Position check on scroll and resize (throttled to one per frame). The theme can re-render the buy
    // buttons, so the main button is looked up again when the stored one has left the page.
    var queued = false;
    function check() {
      queued = false;
      if (!main.isConnected) {
        var fresh = document.querySelector('.product-block-list__item--info .product-form__add-button');
        if (fresh) main = fresh;
      }
      var r = main.getBoundingClientRect();
      mainInView = r.bottom > 0 && r.top < window.innerHeight;
      apply();
    }
    function queue() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(check);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (phone.addEventListener) phone.addEventListener('change', queue);
    check();
  }

  onReady(function () {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    warrantyParagraph();
    galleryCounter();
    stickyBar();
    window.dispatchEvent(new Event('resize'));
  });
})();

/*
 * 5 Oct 2026, Distinct Picks: on the cart page on phones the chat button ("Need help?") floated over the
 * Checkout button. The chat now hides while the Checkout button is on screen and comes back when the buyer
 * scrolls away from it (same pattern as the Add to cart button on product pages). Desktop is unchanged.
 */
(function () {
  function start() {
    if (!document.body || document.body.className.indexOf('template-cart') === -1) return;
    if (!('IntersectionObserver' in window)) return;
    var phone = window.matchMedia('(max-width: 640px)');
    var style = document.createElement('style');
    style.textContent = 'body.dp-checkout-in-view shopify-chat { visibility: hidden; }';
    document.head.appendChild(style);
    var observed = null;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (e) { return e.isIntersecting; });
      document.body.classList.toggle('dp-checkout-in-view', visible && phone.matches);
    });
    function watch() {
      var btn = document.querySelector('.template-cart [name="checkout"]');
      if (!btn || btn === observed) return;
      if (observed) io.unobserve(observed);
      observed = btn;
      io.observe(btn);
    }
    watch();
    new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * 5 Oct 2026, Distinct Picks: cart drawer on phones. With the Add to cart bar always visible on product pages,
 * an open cart drawer had the bar over its bottom and the chat button over the shipping line. While the drawer
 * is open, the bar and the chat are hidden (the line itself carries the phone number) and the extra space
 * kept for the chat is removed. Desktop is unchanged.
 */
(function () {
  function start() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    var style = document.createElement('style');
    style.textContent =
      '@media screen and (max-width: 640px) {' +
      '  body.dp-minicart-open .dp-sticky-atc { display: none; }' +
      '  body.dp-minicart-open shopify-chat { visibility: hidden; }' +
      '  body.dp-minicart-open .mini-cart__recap { padding-bottom: 24px; }' +
      '}';
    document.head.appendChild(style);
    function sync() {
      document.body.classList.toggle('dp-minicart-open', drawer.getAttribute('aria-hidden') === 'false');
    }
    sync();
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
